export default {
  init() {
    function refreshLine() {
      var path1 = jQuery('#path1');
      var path2 = jQuery('#path2');
      var jumbo1 = jQuery('#jumbo-first .hero-content > .hero-content-container');
      var jumbo2 = jQuery('#jumbo-second .hero-content > .hero-content-container');
      var jumbo3 = jQuery('#jumbo-third .hero-content > .hero-content-container');
      var x1, x2, y1, y2;

      x1 = Math.round(jumbo1.offset().left + jumbo1.outerWidth());
      y1 = Math.round(jumbo1.offset().top + jumbo1.outerHeight() - 1);
      x2 = Math.round(jumbo2.offset().left);
      y2 = Math.round(jumbo2.offset().top + 1);
      path1.attr('x1',x1).attr('y1',y1).attr('x2',x2).attr('y2',y2);

      x1 = Math.round(jumbo2.offset().left);
      y1 = Math.round(jumbo2.offset().top + jumbo2.outerHeight() - 1);
      x2 = Math.round(jumbo3.offset().left + jumbo3.outerWidth());
      y2 = Math.round(jumbo3.offset().top + 1);
      path2.attr('x1',x1).attr('y1',y1).attr('x2',x2).attr('y2',y2);
    }

    jQuery( document ).ready(function() {
      refreshLine();
    });

    jQuery( window ).resize(function() {
      refreshLine();
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js